var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item"},[_c('div',[_vm._v("在租客户总数")]),_vm._m(0),_c('div',{staticClass:"rate"},[_vm._v("占总住户92%")]),_c('div',{staticClass:"chart"},[_c('BaseChart',{attrs:{"option":_vm.baseOption}})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"value"},[_c('span',{staticStyle:{"font-size":"36px"}},[_vm._v("85")]),_c('span',{staticStyle:{"font-size":"18px"}},[_vm._v("个")])])
}]

export { render, staticRenderFns }